import React from "react";
import "./CustomToast.css";

const CustomToast = ({ title, content , onConfirm, onCancel,  blocks = [], isNotifyMultiple}) => (
  <div className="flex flex-col items-start justify-center w-full pl-2.5">
    <strong>{title}</strong>
    <div className="text-[15px] ">{content}</div>

    {isNotifyMultiple && (<div>Note: Any text overflowing in the credits preview won't apper in the final rendered video.</div>)}
     {isNotifyMultiple && (
        <ul className="flex flex-col items-start" style={{ marginTop: 8 }}>
          {blocks.map((block) => (
            <li key={block.index}>
               Credit Block : {block.name}
            </li>
          ))}
        </ul>
      )}

    {onConfirm && (
      <div className="w-full relative -right-[25px] flex justify-end items-center gap-3 mt-2 pb-1">      
        <button className="cancell_btn" onClick={onCancel}>Cancel</button>
        <button className="confirm_btn" onClick={onConfirm}>Confirm</button>
      </div>
    )}

  </div>
);

export default CustomToast;

export const defaultcustomToatStyle = {
  position: "top-center",
  className: "Customtoastpop",
  autoClose: false,
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  progressStyle: { background: "#222222" },
  theme: "colored",
  style: {
    background: "#181621",
    color: "#fff",
    width:"100%",
    maxWidth: "360px",
    outline: "1px solid  #ffffff13",
    borderRadius: "16px",
    paddingRight: "14px",
    position: "fixed",
    fontFamily:"manrope",
  },
};

export const customToatStyle = {
  position: "top-center",
  className: "Customtoastpop",
  autoClose: true,
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  progressStyle: { background: "#222222" },
  theme: "colored",
  style: {
    background: "#222222",
    color: "#fff",
    width: "300px",
    outline: "1px solid  rgba(84, 96, 108, 1)",
    borderRadius: "16px",
    paddingRight: "14px",
    position: "fixed",
    right: "43%",
    fontFamily:"manrope",
  },
};


export const customToatStyleError = {
  position: "top-center",
  className: "Customtoastpop",
  autoClose: false,
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  progressStyle: { background: "#222222" },
  theme: "colored",
  style: {
    background: "#222222",
    color: "#fff",
    width: "450px",
    outline: "1px solid  rgba(84, 96, 108, 1)",
    borderRadius: "16px",
    paddingRight: "14px",
    position: "fixed",
    right: "20%",
    fontFamily:"manrope"
  },
};
